@if ((bewegungen?.length || 0) > 0) {
  @for (bewegung of bewegungen; track trackByFn($index, bewegung)) {
    <div
      class="mt-4 soft-card rounded-sm border border-primary border-solid !p-0"
      >
      <div class="flex flex-row m-3 pb-2">
        <div
          class="flex flex-col justify-between w-full gap-2"
        [ngClass]="{
          'border-b border-solid':
            bewegung.auftrag || (bewegung?.zeilentext && bewegung?.zeilentext !== ''),
        }"
          >
          <div class="flex flex-col w-full gap-0.5">
            <div class="flex items-center gap-2">
              <p class="font-semibold">
                @if ((bewegung?.lfdnr?.toString()?.length ?? 0) === 1) {
                  <span
                    >00{{ bewegung?.lfdnr }}</span
                    >
                  }
                  @if ((bewegung?.lfdnr?.toString()?.length ?? 0) === 2) {
                    <span
                      >0{{ bewegung?.lfdnr }}</span
                      >
                    }
                    @if ((bewegung?.lfdnr?.toString()?.length ?? 0) >= 3) {
                      <span>{{
                        bewegung?.lfdnr
                      }}</span>
                    }
                  </p>
                  @if (bewegung.idReklamation) {
                    <soft-icon name="fa-regular fa-triangle-exclamation"></soft-icon>
                  }
                  @if (bewegung?.artikelMenge?.artikel?.lplfuehrung === false) {
                    <soft-icon
                      softToolTip="Nicht Lagerplatzgeführt"
                      name="fa-regular fa-warehouse text-danger"
                      class="text-danger"
                    ></soft-icon>
                  }
                  @if ($safeNavigationMigration(bewegung?.bestellnummer) | isDefinedNotEmpty) {
                    <div
                      class="bg-primary-50 ml-1 px-2 rounded-full overflow-clip whitespace-nowrap border border-primary"
                      >
                      <div class="font-normal text-sm text-primary truncate w-auto">
                        Bestellung {{ bewegung?.bestellnummer }}
                      </div>
                    </div>
                  }
                </div>
                <p class="mt-0.5">
                  @if (bewegung.artikelMenge?.artikel?.lieferantArtikelNummer) {
                    <span>
                      {{
                      '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_LIEFERANT_ARTIKELNUMMER' | translate
                      }}
                      {{ bewegung.artikelMenge?.artikel?.lieferantArtikelNummer ?? '' }} |
                    </span>
                  }
                  @if (bewegung.artikelMenge?.artikel?.ean) {
                    <span>
                      {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_EAN' | translate }}
                      {{ bewegung.artikelMenge?.artikel?.ean }} |
                    </span>
                  }
                  {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_ARTIKELNUMMER' | translate }}
                  {{ bewegung.artikelMenge?.artikel?.nummer ?? '' }}
                </p>
                <p class="font-semibold text-lg">
                  {{ bewegung.artikelMenge.artikel?.artbez1 ?? '-' }}
                </p>
            <!--  Weitere Artikel Bezeichnungen   -->
                @if (
                  bewegung.artikelMenge.artikel?.artbez2 &&
                  bewegung.artikelMenge.artikel?.artbez2 !== ''
                  ) {
                  <p
                    class="text-light"
                    >
                    {{ bewegung.artikelMenge.artikel?.artbez2 }}
                  </p>
                }
                @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez3) | isDefinedNotEmpty) {
                  <span class="text-sm text-light">{{
                    bewegung.artikelMenge.artikel?.artbez3
                  }}</span>
                }
                @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez4) | isDefinedNotEmpty) {
                  <span class="text-sm text-light">{{
                    bewegung.artikelMenge.artikel?.artbez4
                  }}</span>
                }
                @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez5) | isDefinedNotEmpty) {
                  <span class="text-sm text-light">{{
                    bewegung.artikelMenge.artikel?.artbez5
                  }}</span>
                }


            <!--  Dimensions beschreibung wenn DIM Artikel   -->
                @if (bewegung?.dimension && bewegung?.dimension?.massUnitId) {
                  <div class="mt-1">
                    <span class="italic font-semibold text-sm mt-1">{{
                      bewegung?.dimension?.massUnitId
                    }}</span>
                  </div>
                }
              </div>


              <div class="flex flex-col mt-2 w-full gap-1">
                <div class="flex flex-row flex-wrap w-full gap-2 justify-end items-stretch">
                  @if (!hasSubItems(bewegung)) {
                    <soft-mengen-eingabe
                      #mengenEingabe
                      [disabled]="bewegung.status === 'E'"
                      [float]="true"
                      [value]="bewegung.artikelMenge.menge ?? 0"
                      (valueChange)="
                        mengeChange.emit({ bewe: bewegung, menge: mengenEingabe.value })
                      "
                      [preventKeyboardEventEmission]="true"
                      [einheit]="bewegung.artikelMenge?.einheit?.arteh ?? '' | uppercase"
                      class="w-full md:w-auto"
                      [ngClass]="{
                        'soft-mengen-eingabe-order': isBestellung || bewegung.status === 'E',
                      }"
                      >
                    </soft-mengen-eingabe>
                  }


                  <!--  Funktionen für Artikel Typ: DIF & SDIF   -->
                  @if (!bewegung.artikelMenge?.artikel?.kzartikelart || (bewegung.artikelMenge?.artikel?.kzartikelart !== 'DIF' && bewegung.artikelMenge?.artikel?.kzartikelart !== 'SDIF')) {
                    @if (
                      (!isBestellung && bewegung.status !== 'E') ||
                      (isBestellung && bewegung.status !== 'O') ||
                      !isBestellung
                      ) {
                      <div class="flex flex-row gap-2 items-stretch">
                        @if (
                          (!isBestellung && bewegung.status !== 'E') ||
                          (isBestellung && bewegung.status !== 'O')
                          ) {
                          <!--  Mengen Eingabe Öffnen   -->
                          @if (bewegung?.einheitenEingabeErlaubt) {
                            <button
                              class="soft-button primary flex items-center justify-center text-white min-w-[3.5rem] rounded-sm w-16"
                              (click)="mengenEingabeOeffnen.emit(bewegung)"
                            >
                              @if (hasSubItems(bewegung)) {
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  stroke-width="1.5"
                                  class="w-6 h-6 fill-current text-white"
                                >
                                  <path
                                    d="M272 48L112 48l0 160 160 0 0-160zM112 0L272 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0zM528 112l-96 0 0 96 96 0 0-96zM432 64l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM0 344c0-13.3 10.7-24 24-24l64 0 232 0 232 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 96 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-232 0L88 512l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-96-40 0c-13.3 0-24-10.7-24-24zM112 464l184 0 0-96-184 0 0 96zm232 0l184 0 0-96-184 0 0 96z"
                                  />
                                </svg>
                              } @else {
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-6 h-6"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
                                  />
                                </svg>
                              }
                            </button>
                          }
                        }

                        <!--  Position Erledigen oder Öffnen   -->
                        @if (!isBestellung) {
                          <button
                            class="soft-button primary flex items-center justify-center text-white min-w-[3.5rem] rounded-sm w-16"
                            (click)="statusChange.emit(bewegung)"
                          >
                            @if (bewegung.status === 'O') {
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                            }
                            @if (bewegung.status === 'E') {
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                                />
                              </svg>
                            }
                          </button>
                        }


                        <!--  Lagerplatz auswahl - Direktannahme   -->
                        @if (
                          config?.dierektannahme &&
                          bewegung.artikelMenge.artikel.lplfuehrung &&
                          bewegung.status !== 'E'
                          ) {
                          <div
                            class="flex flex-col md:flex-row flex-nowrap md:justify-between gap-2 h-full"
                          >
                            <button
                              class="bg-surface border h-full border-solid border-primary rounded px-4 py-2 cursor-pointer shadow text-left w-full hover:bg-hover"
                              (click)="openCustomSelect(bewegung)"
                            >
                              <div class="flex flex-row">
                                <div class="flex items-center align-middle">
                                  <i class="fa-regular fa-shelves fa-2x"></i>
                                </div>
                                <div class="flex flex-col ml-4 hidden lg:flex">
                                  <div class="font-semibold text-lg">
                                    {{
                                      '#LAGERPLATZ_CORE.COMPONENTS.LAGERPLATZ_SUCHE.TITLE'
                                        | translate
                                    }}
                                  </div>
                                </div>
                              </div>
                            </button>
                          </div>
                          <!--
                          <soft-lagerplatz-suche
                            [hideScan]="true"
                            [(lagerplatz)]="resetLagerplatz"
                      (lagerplatzChange)="
                        lagerplatzChange.emit({ bewe: bewegung, lagerplatz: $event })
                      "
                          ></soft-lagerplatz-suche> -->
                        }
                      </div>
                    }
                  }

                </div>

<!--             TODO: add prüfung auf artikelart 'DIM' und 'SDIM'-->
                @if (bewegung.dimensionen; as dimensionen) {
                  <div class="text-sm font-semibold mt-1">Dimensionen</div>
                  @for (dimension of dimensionen; track dimension.id) {
                    <div class="mt-1">
                      <span class="italic font-semibold text-sm mt-1">{{
                          dimension?.massUnitId
                        }}</span>
                    </div>
                    <soft-mengen-eingabe
                      #mengenEingabe
                      [disabled]="bewegung.status === 'E'"
                      [float]="true"
                      [value]="dimension.menge ?? 0"
                      (valueChange)="
                          dimensionenMengeChange.emit({ bewe: bewegung, dimension: {menge: mengenEingabe.value, id: dimension.id} })
                        "
                      [einheit]="bewegung.artikelMenge?.einheit?.arteh ?? '' | uppercase"
                      [preventKeyboardEventEmission]="true"
                      class="w-full md:w-auto"
                      [ngClass]="{
                          'soft-mengen-eingabe-order': isBestellung || bewegung.status === 'E',
                        }"
                    />
                  }
                }


                @if (hasSubItems(bewegung) && (bewegung?.artikelMenge?.artikel?.kzartikelart !== 'DIF' && bewegung?.artikelMenge?.artikel?.kzartikelart !== 'SDIF' )) {
                  <div class="flex gap-2 items-start justify-start">
                    <p class="text-sm text-light">
                      {{ bewegung?.anzahlPalette }}/{{ bewegung?.anzahlPalettenSoll }} Paletten:
                    </p>
                    <div class="flex flex-col gap-0.5">
                      @for (pal of bewegung?.paletten ?? []; track $index) {
                        <span class="text-sm text-light">
                          {{ pal?.sscc }}
                          @if ($safeNavigationMigration(pal?.extref) | isDefinedNotEmpty) {
                            ({{ pal?.extref ?? '' }})
                          }
                        </span>
                      }
                    </div>
                  </div>
                } @else {
                  <!--  Gesamt in anderer einheit   -->
                  <!--  Bsp: = 0.788 M3   -->
                  @if (!isBestellung && !(bewegung.artikelMenge?.artikel?.kzartikelart === 'DIF' || bewegung.artikelMenge?.artikel?.kzartikelart === 'SDIF')) {
                    <p class="text-sm text-light">
                      = {{ bewegung?.artikelMenge?.menge_lg }}
                      {{ bewegung?.artikelMenge?.einheit_lg?.arteh ?? '' | uppercase }}
                    </p>
                  }
                }
                <!--  Anzeige Lagerplatz   -->
                @if (bewegung?.lagerplatz && (bewegung?.lagerplatz?.length || 0) > 0) {
                  <p
                    class="text-sm font-semibold ml-auto"
                    >
                    {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_LAGER' | translate }}
                    {{ bewegung?.lagerplatz }}
                  </p>
                }

              </div>
            </div>
            @if (
              (config?.dierektannahme && bewegung.artikelMenge.artikel.lplfuehrung) ||
              (config?.reklamation && hasReklamationPermission())
              ) {
              <div class="flex m-2">
                <div class="flex justify-center text-center">
                  <soft-icon
                    (click)="actionClick.emit(bewegung)"
                    class="p-1 size-7 text-center rounded hover:bg-gray-200 cursor-pointer"
                    name="fa-regular fa-ellipsis-vertical"
                  ></soft-icon>
                </div>
              </div>
            }
          </div>
          @if (bewegung?.auftrag) {
            <div
              class="flex flex-col m-3 gap-2"
      [ngClass]="{
        'border-b border-solid pb-4': bewegung?.zeilentext && bewegung?.zeilentext !== '',
      }"
              >
              <p class="text-light">
                {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_AUFTRAG' | translate }}
                {{ bewegung?.auftrag?.auftragnr }}
              </p>
              <p class="text-light">
                {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_KUNDE' | translate }}
                {{ bewegung.auftrag?.kunde?.kundennummer }}
                {{ bewegung.auftrag?.kunde?.kurzbez }} |
                {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_ADRESSE' | translate }}
                {{ bewegung.auftrag?.kunde?.strasse
                }}@if (bewegung.auftrag?.kunde?.strassenr) {
                {{ bewegung.auftrag?.kunde?.strassenr }}
                }, {{ bewegung.auftrag?.kunde?.plz }} {{ bewegung.auftrag?.kunde?.ort }}
              </p>
            </div>
          }
          @if (bewegung?.zeilentext && bewegung?.zeilentext !== '') {
            <div
              class="flex flex-row w-full p-3"
              >
              <p class="text-light mb-2">
                {{ bewegung?.zeilentext }}
              </p>
            </div>
          }

      @if (bewegung.artikelMenge?.artikel?.kzartikelart === 'DIF' || bewegung.artikelMenge?.artikel?.kzartikelart === 'SDIF') {
        @if ((bewegung.bewelgs?.length ?? 0) > 0) {
          <div class="border-t border-solid mt-1 mx-3 mb-3 pt-2">
            <div class="flex flex-col gap-1">
              @for (bewelg of bewegung.bewelgs ?? []; track $index) {
                <div class="flex flex-row items-center justify-between text-sm gap-2">
                    <span class="text-light font-medium">
                      {{ $safeNavigationMigration(bewelg.einheit_lf?.arteh) | uppercase }}
                    </span>
                </div>

                <div class="flex items-stretch gap-2 lg:max-w-1/2">
                  <soft-mengen-eingabe
                    [disabled]="bewelg.status === 'E'" class="w-full"
                    [value]="bewelg.liefmenge_offen"
                    [einheit]="$safeNavigationMigration(bewelg.einheit_lf?.arteh)"
                    [preventKeyboardEventEmission]="true"
                    (valueChange)="bewelgMengeChange.emit({ bewe: bewegung, bewelg, menge: $event })"
                  >

                  </soft-mengen-eingabe>
                  @if (!isBestellung) {
                    <button
                      class="soft-button primary flex items-center justify-center text-white w-20 rounded-sm"
                      (click)="beweLgStatusChange.emit({ bewe: bewegung, bewelg: bewelg  })"
                    >
                      @if (bewelg.status === 'O') {
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.5 12.75l6 6 9-13.5"
                          />
                        </svg>
                      }
                      @if (bewelg.status === 'E') {
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                          />
                        </svg>
                      }
                    </button>

                    @if (
                      config?.dierektannahme &&
                      bewegung.artikelMenge.artikel.lplfuehrung &&
                      bewelg.status !== 'E'
                      ) {
                      <div
                        class="flex flex-col md:flex-row flex-nowrap md:justify-between gap-2 h-full"
                      >
                        <button
                          class="bg-surface border h-full border-solid border-primary rounded px-4 py-2 cursor-pointer shadow text-left w-full hover:bg-hover"
                          (click)="openCustomSelect(bewegung, bewelg)"
                        >
                          <div class="flex flex-row">
                            <div class="flex items-center align-middle">
                              <i class="fa-regular fa-shelves fa-2x"></i>
                            </div>
                            <div class="flex flex-col ml-4 hidden lg:flex">
                              <div class="font-semibold text-lg">
                                {{
                                  '#LAGERPLATZ_CORE.COMPONENTS.LAGERPLATZ_SUCHE.TITLE'
                                    | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </button>
                      </div>
                      <!--
                      <soft-lagerplatz-suche
                        [hideScan]="true"
                        [(lagerplatz)]="resetLagerplatz"
                  (lagerplatzChange)="
                    lagerplatzChange.emit({ bewe: bewegung, lagerplatz: $event })
                  "
                      ></soft-lagerplatz-suche> -->
                    }
                  }
                </div>

                @if ($safeNavigationMigration(bewelg?.lagerplatz) | isDefinedNotEmpty) {
                  <span class="text-light text-xs italic">{{ bewelg.lagerplatz?.['lagerplatz'] }}</span>
                }
              }
            </div>
          </div>
        }
      }
        </div>
      }
} @else {
  <div
    class="flex items-center justify-center text-center text-sm text-lighter py-4 mt-2"
    >
    {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_KEINE_BEWEGUNGEN' | translate }}
  </div>
}


@let palletItemList = palletItems();

@if (!!palletItemList && palletItemList.length > 0) {
  <div class="flex flex-col w-full mt-3">
    <div class="my-1 text-sm font-semibold border-b pb-1 mb-1.5">Paletten</div>

    <div class="flex flex-col mb-2 pb-2 w-full gap-2">
      @for (palletItem of palletItemList; track palletItem.palette.id) {
        <div class="soft-card rounded-sm border border-primary border-solid !p-0">
          <div class="flex flex-col px-3 items-start pt-3">
            <span class="soft-overline">Palette</span>
            <span class="text-lg font-semibold">{{ palletItem.palette.sscc }}</span>
            <span class="text-base text-light">{{ palletItem?.palette?.extref }}</span>
            <span class="text-base text-light">Lagerplatz: {{ palletItem?.lagerplatz?.lagerplatz }}</span>
          </div>

          <div class="grid grid-cols-3 p-3 gap-3">
            <button
              class="soft-button primary h-14 rounded flex items-center justify-center min-w-[3.5rem] rounded-sm"
          (click)="
            openPalletItemsList(palletItem);
            $event.stopPropagation();
            $event.preventDefault()
          "
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                stroke-width="1.5"
                class="w-6 h-6 fill-current text-primary-contrast"
                >
                <path
                  d="M272 48L112 48l0 160 160 0 0-160zM112 0L272 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0zM528 112l-96 0 0 96 96 0 0-96zM432 64l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM0 344c0-13.3 10.7-24 24-24l64 0 232 0 232 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 96 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-232 0L88 512l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-96-40 0c-13.3 0-24-10.7-24-24zM112 464l184 0 0-96-184 0 0 96zm232 0l184 0 0-96-184 0 0 96z"
                  />
              </svg>
            </button>
            <button
              (click)="toggleCompleteOpen(palletItem)"
              class="soft-button primary h-14 rounded flex items-center justify-center min-w-[3.5rem] rounded-sm"
              >
              @if (palletItem.status === 'O') {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4.5 12.75l6 6 9-13.5"
                    />
                </svg>
              }
              @if (palletItem.status === 'E') {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                    />
                </svg>
              }
            </button>

            @if (palletItem.status !== 'E') {
              <button
                class="bg-surface border h-full border-solid border-primary rounded px-4 py-2 cursor-pointer shadow text-left w-full hover:bg-hover"
                (click)="selectStorageLocation(palletItem)"
              >
                <div class="flex flex-row">
                  <div class="flex items-center align-middle">
                    <i class="fa-regular fa-shelves fa-2x"></i>
                  </div>
                  <div class="flex flex-col ml-4 hidden lg:flex">
                    <div class="font-semibold text-lg">
                      {{
                        '#LAGERPLATZ_CORE.COMPONENTS.LAGERPLATZ_SUCHE.TITLE'
                          | translate
                      }}
                    </div>
                  </div>
                </div>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
